import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-244d6a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FeaturedFirst" }
const _hoisted_2 = { class: "FeaturedFirst-category" }
const _hoisted_3 = { class: "FeaturedFirst-banner" }


import CategoryTaobao from './CategoryTaobao.vue'
import CategoryTmall from './CategoryTmall.vue'
import Category1688 from './Category1688.vue'
import FeaturedBanner from './FeaturedBanner.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.type === 'taobao')
        ? (_openBlock(), _createBlock(CategoryTaobao, { key: 0 }))
        : _createCommentVNode("", true),
      (__props.type === 'tmall')
        ? (_openBlock(), _createBlock(CategoryTmall, { key: 1 }))
        : _createCommentVNode("", true),
      (__props.type === '1688')
        ? (_openBlock(), _createBlock(Category1688, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FeaturedBanner, { type: __props.type }, null, 8, ["type"])
    ])
  ]))
}
}

})